module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-holidays-242547094cf1803e953000a43a5f8dae.webp";